<app-loader [isLoading]="isLoading"></app-loader>
@if(isUuid){
<router-outlet></router-outlet>
}@else {

<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
  @if(myroles.can_write){
  <div class="top">
    <div class="boton">
      <button class="b1" mat-button (click)="addMail()">Añadir consulta</button>
    </div>
  </div>
  }
</div>

<div class="content">
  <div class="filter">
    <div class="left-section">
      <div class="search-section">
        <mat-form-field appearance="outline" id="toppings">
          <mat-label>Estado</mat-label>
          <mat-select [formControl]="toppings" multiple>
            @for (topping of toppingList; track topping) {
            <mat-option [value]="topping">{{ topping }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="filter-buttons">
        @for (filter of filters; track filter.value){
        <button [class.active]="selectedFilter === filter.value" (click)="selectFilter(filter.value)">
          {{ filter.label }}
        </button>
        }
      </div>
    </div>
    <div class="paginator-container">
      <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of the relation table"
        class="paginator-field">
      </mat-paginator>
    </div>
  </div>
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8 table">
    <!-- Columna de Título -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>TÍTULO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px" [innerHTML]="element.title | mailTitle"></span>
      </td>
    </ng-container>

    <!-- Columna de Autor -->
    <ng-container matColumnDef="author">
      <th mat-header-cell *matHeaderCellDef>AUTOR</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{
          element.employee_external_id | qeqPipe
          }}</span>
      </td>
    </ng-container>

    <!-- Columna de Id -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.employee_external_id }}</span>
      </td>
    </ng-container>

    <!-- Columna de Estado -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ESTADO</th>
      <td mat-cell *matCellDef="let element">
        @if(element.status === 'Aceptada'){
        <button mat-flat-button id="consumed">
          <mat-icon matTextPrefix>check_circle</mat-icon>
          <span style="font-size: 16px">{{ element.status }}</span>
        </button>
        }@else if (element.status === 'En trámite') {
        <button mat-flat-button id="reservation">
          <mat-icon matTextPrefix svgIcon="pending"></mat-icon>
          <span style="font-size: 16px">{{ element.status }}</span>
        </button>
        }@else if (element.status === 'Declinada') {
        <button mat-flat-button id="non-consumed">
          <mat-icon matTextPrefix>cancel</mat-icon>
          <span style="font-size: 16px">{{ element.status }}</span>
        </button>

        } @else {
        <button mat-flat-button id="started">
          <mat-icon matTextPrefix svgIcon="psychology"></mat-icon>
          <span style="font-size: 16px">{{ element.status }}</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de Tipos -->
    <ng-container matColumnDef="types">
      <th mat-header-cell *matHeaderCellDef>TIPO</th>
      <td mat-cell *matCellDef="let element">
        @if(element.types === 'Felicitación'){
        <button mat-flat-button id="consumed">
          <span style="font-size: 16px">{{ element.types }}</span>
        </button>
        }@else if (element.types === 'Sugerencia') {
        <button mat-flat-button id="started">
          <span style="font-size: 16px">{{ element.types }}</span>
        </button>
        } @else {
        <button mat-flat-button id="non-consumed">
          <span style="font-size: 16px">{{ element.types }}</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de Fecha de envío -->
    <ng-container matColumnDef="send-date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="created_when">
        ENVIADO
      </th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{
          element.created_when | customPipe
          }}</span>
      </td>
    </ng-container>

    <!-- Columna de Fecha de actualización de estado -->
    <ng-container matColumnDef="updated-status-date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="updated_at">
        ACTUALIZACIÓN ESTADO
      </th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{
          element.updated_at | customPipe
          }}</span>
      </td>
    </ng-container>

    <!-- Columna de Acciones -->
    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <!-- <button mat-icon-button class="acciones"><mat-icon style="color: #2D3872;">info_outline</mat-icon></button> -->
        @if(myroles.can_write){
        <button mat-icon-button class="acciones" (click)="goToMail(element.id)">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        } @if(myroles.can_delete){
        <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.title)">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
}